module.exports = __webpack_public_path__ + "static/media/recommendation-counter.61f5f93c.svg";